<template>
  <button-line
    :items="items"
    v-bind="$attrs"
  />
</template>

<script>
import ButtonLine from "./ButtonLine";
import { mapGetters } from 'vuex';

/**
 * Component PAButtonLine.vue
 *
 * @module PAButtonLine
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.7] app/src/APP_DASHBOARD/templates/components/Parts/PAButtonLine.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PAButtonLine",
  components: {
    ButtonLine,
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
    firstButtonTitle: function () {
      const v = parseInt(this.$store.getters['patientSummary/currentVersion']);

      if (v <= 2) {
        return this.$ucfirst(this.$t("journeyBehaviourChangeGoals.status"));
      }

      return this.$ucfirst(this.$t("journeyProgress.progress"));
    },
    items() {
      return [
        {
          label: this.firstButtonTitle,
          route: {
            name: 'PatientRecordPAProgress',
            params: {
              patientId: this.patientId,
              title: this.firstButtonTitle,
            },
          },
        },
        {
          label: this.$ucfirst(this.$t('journeyProgress.goalSetting')),
          route: {
            name: 'PatientRecordPAGoalSetting',
            params: { patientId: this.patientId },
          },
        },
        // Note: Release 2.0 scope reduction
        // {
        //   label: $ucfirst($t('pa.summary')),
        //   route: {
        //     name: 'PatientRecordPASummary',
        //     params: { patientId: this.patientId },
        //   },
        // },
      ]
    }
  },
};
</script>

<style lang="scss">
</style>
